import { FluidTableConditionalDisableOptions } from '@lmig/fluid-core';

import { ID } from '../../../constants/constants';
import { Utils } from '../../../utils/utils';
import { FluidTable } from '../fluid-table';
import { updateEditableCellDisabledCache } from './fluid-table-cache.utils';
import { getMutatedDataItem } from './fluid-table-editable-cell-management.utils';
import { getEditableFormReferences } from './fluid-table-form.utils';

export const setTableDisabled = (
  host: Partial<FluidTable>,
  disabled: boolean
) => {
  host.actionsDisabled = disabled;
  getEditableFormReferences(host._editableForms).forEach(
    (form: HTMLFluidFormElement) => {
      form.setDisabled(disabled);
    }
  );

  Object.keys(host._editableCells).forEach((rowId) => {
    Object.keys(host._editableCells[rowId]).forEach((dataPath) => {
      updateEditableCellDisabledCache(
        host as FluidTable,
        rowId,
        dataPath,
        disabled
      );
      host._editableCells[rowId][dataPath].reference.setDisabled(disabled);
    });
  });
};

export const restoreOriginalTableConfiguration = (
  host: Partial<FluidTable>
) => {
  getEditableFormReferences(host._editableForms).forEach(
    (form: HTMLFluidFormElement) => {
      form.restoreOriginalConfiguration(true);
    }
  );
  host._tableDisabled = host.disabled;
};

export const setFieldsDisabledConditionally = (
  host: Partial<FluidTable>,
  disabled,
  opt: FluidTableConditionalDisableOptions
): void => {
  opt.dataPaths.forEach((dataPath) =>
    handleDisabledFormFields(host, disabled, dataPath, opt.setDisabledIf)
  );
  Object.keys(host._editableCells).forEach((rowId) => {
    opt.dataPaths.forEach((dataPath) =>
      handleDisableEditableCells(
        host,
        disabled,
        rowId,
        dataPath,
        opt.setDisabledIf
      )
    );
  });
};

export const handleDisabledFormFields = (
  host: Partial<FluidTable>,
  disabled,
  dataPath,
  setDisabledIf
): void => {
  host._dataSource.forEach((dataItem) => {
    if (
      setDisabledIf(getMutatedDataItem(host, dataItem)) &&
      !Utils.isEmptyObject(host._editableForms)
    ) {
      host._editableForms?.[dataItem[ID]]?.setDisabled(disabled, dataPath);
    }
  });
};

export const handleDisableEditableCells = (
  host: Partial<FluidTable>,
  disabled,
  rowId,
  dataPath,
  setDisabledIf
): void => {
  const dataItem = host._dataSource.find((ds) => ds[ID] === rowId);
  if (
    !!dataItem &&
    host._editableCells[rowId][dataPath] &&
    setDisabledIf(getMutatedDataItem(host, dataItem))
  ) {
    updateEditableCellDisabledCache(
      host as FluidTable,
      rowId,
      dataPath,
      disabled
    );
    host._editableCells[rowId][dataPath].reference.setDisabled(disabled);
  }
};
